import React from "react";

import { useCandles, useTokenBySymbol, useTokensByIds } from "lib/graphql";

export default function GraphqlSandbox() {
  const { data: tokensData, loading: tokensLoading, error: tokensError } = useTokensByIds(["USDC", "RWA", "WRWA"]);
  const { data: tokenData, loading: tokenLoading } = useTokenBySymbol("RWA");

  const now = Math.floor(Date.now() / 1000);
  const { data: candlesData, loading: candlesLoading } = useCandles({
    marketId: "RWA",
    interval: "1m",
    from: now - 3600,
    to: now,
  });

  return (
    <div style={{ padding: 24 }}>
      <h2>GraphQL Sandbox</h2>
      <section>
        <h3>tokens(ids: [USDC, RWA, WRWA])</h3>
        {tokensLoading ? (
          <div>Loading tokens…</div>
        ) : tokensError ? (
          <pre>{String(tokensError)}</pre>
        ) : (
          <pre>{JSON.stringify(tokensData, null, 2)}</pre>
        )}
      </section>
      <section>
        <h3>tokenBySymbol(symbol: "RWA")</h3>
        {tokenLoading ? <div>Loading token…</div> : <pre>{JSON.stringify(tokenData, null, 2)}</pre>}
      </section>
      <section>
        <h3>candles(marketId: "RWA", interval: "1m", last 1h)</h3>
        {candlesLoading ? (
          <div>Loading candles…</div>
        ) : (
          <pre>{JSON.stringify(candlesData?.candles?.slice(0, 5), null, 2)}</pre>
        )}
      </section>
    </div>
  );
}
